import { useCustomizeUIData } from "@circle-react/components/shared/CustomizeUI";
import type { Event } from "@circle-react/types";
import { SECTIONS } from "../../utils";
import { AttendeesPreview } from "./AttendeesPreview";
import { CohostsPreview } from "./CohostsPreview";
import { LatestRSVP } from "./LatestRSVP";
import { Summary } from "./Summary";

interface OverviewProps {
  event: Event;
}

export const Overview = ({ event }: OverviewProps) => {
  const { setCurrentSection } = useCustomizeUIData();
  const goToPeople = () => setCurrentSection(SECTIONS.people);

  return (
    <>
      <Summary event={event} />
      <div className="my-4 flex flex-col items-stretch gap-4 md:my-6 md:flex-row">
        <div className="w-full pr-0 md:w-1/2 md:pr-3">
          <AttendeesPreview event={event} onClick={goToPeople} />
        </div>
        <div className="w-full pl-0 md:w-1/2 md:pl-3">
          <CohostsPreview event={event} onClick={goToPeople} />
        </div>
      </div>
      <div className="mt-4 md:my-6">
        <LatestRSVP event={event} />
      </div>
    </>
  );
};
